import { SlideGameCardsProps } from './props';
import { Card, Hexagon, HexagonImage, Profit } from './styles';

export default function SlideGameCard({
  hasStopedSlide,
  tile,
  winner,
}: SlideGameCardsProps): JSX.Element {
  return (
    <Card isWinner={winner} animate={hasStopedSlide} color={tile?.type?.color}>
      <Hexagon
        animate={hasStopedSlide}
        isWinner={winner}
        color={tile?.type?.color}
      >
        <HexagonImage
          width="89"
          height="101"
          viewBox="0 0 89 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_378_5832)">
            <path
              d="M88.3547 73.3818V27.2774C88.372 25.8812 87.6329 24.5847 86.4225 23.8886L46.4913 0.847217C45.2959 0.157048 43.8231 0.157048 42.6277 0.847217L2.718 23.8886C1.52109 24.5771 0.784104 25.8534 0.785884 27.2342V73.3818C0.768499 74.778 1.50758 76.0745 2.718 76.7706L42.6493 99.812C43.8447 100.502 45.3175 100.502 46.5129 99.812L86.4225 76.7706C87.6329 76.0745 88.372 74.778 88.3547 73.3818Z"
              className="outside"
            />
            <path
              d="M79.6261 68.5826V32.0289C79.628 30.809 78.9773 29.6815 77.9205 29.0733L46.2759 10.7869C45.2204 10.1772 43.9201 10.1772 42.8646 10.7869L11.22 29.0733C10.1633 29.6815 9.51256 30.809 9.51441 32.0289V68.5826C9.51256 69.8025 10.1633 70.93 11.22 71.5382L42.8646 89.8723C43.9201 90.482 45.2204 90.482 46.2759 89.8723L77.9205 71.5382C78.9773 70.93 79.628 69.8025 79.6261 68.5826Z"
              className="inside"
            />
          </g>
          <defs>
            <clipPath id="clip0_378_5832">
              <rect width="89" height="101" fill="white" />
            </clipPath>
          </defs>
          <defs>
            <linearGradient
              id="reflexo-gradient"
              gradientTransform="scale(1, -1)"
            >
              <stop offset="0%" stopColor="white" stopOpacity="0" />
              <stop offset="50%" stopColor="white" stopOpacity="0.5" />
              <stop offset="100%" stopColor="white" stopOpacity="0" />
            </linearGradient>
          </defs>
        </HexagonImage>
        <Profit>{tile?.multiplier?.toNumberString()}x</Profit>
      </Hexagon>
    </Card>
  );
}
